<template>
  <div class="fzmOrderCheckout fzmPaymentDetails">

    <div class="orderCheckoutBody">
        <div class="container">
            <b-row>
                <b-col lg="5">
                    <img src="@/assets/img/orderSummaryImage.png" alt="">
                </b-col>

                <b-col lg="6" offset-lg="1">
                    <button 
                        @click="$router.push({name : 'checkout'})" 
                        class="btn btn-primary backbtn">Back</button>

                    <div class="orderCheckoutHeader">
                        <div class="row">
                            <div class="col-6">
                                <h1>Payment Details</h1>
                            </div>

                            <div class="col-6">
                                <button 
                                    :disabled="disablenextbtn"
                                    @click.prevent="scheduleselection"
                                    class="btn-right btn btn-primary">
                                    Schedule
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="paymentDetailsBody">
                        <div class="paymentOrderBoxes">
                            <h3>12 COUNT HOLES DONUTS</h3>
                            <h2>{{orderboxes.length}} Boxes - ${{ordersummary.grandtotal}}</h2>
                        </div>

                        <div class="paymentCardDetail">
                            <b-tabs  
                                v-model="activetab"
                                content-class="mt-3">
                                <b-tab title="Existing Cards" active>
                                     <b-form-group class="usercreditcards"  v-slot="{ ariaDescribedby }">
                                        
                                         <template v-for="card in usercreditcards">
                                            <b-form-radio 
                                                @change="getcarddetails(card)"
                                                :key="card.id"
                                                v-model="selectedcard" 
                                                :aria-describedby="ariaDescribedby" 
                                                name="some-radios" 
                                                :value="card.id">
                                                
                                                <template v-if="card.card_provider == 'MC'">
                                                    <img src="@/assets/img/mastercard.png" alt=""> 

                                                </template>

                                                <template v-else-if="card.card_provider == 'VISA'">
                                                    <img src="@/assets/img/visalogo.png" alt=""> 
                                                </template>

                                                <template v-else-if="card.card_provider == 'AMEX'">
                                                    <img src="@/assets/img/amex.png" alt=""> 
                                                </template>

                                                <template v-else-if="card.card_provider == 'JCB'">
                                                    <img src="@/assets/img/jcb.jpeg" alt=""> 
                                                </template>
                                                ending in {{card.card_last_four_digit}} {{card.card_expiry | formatcardexpiration}}
                                            </b-form-radio>
                                         </template>

                                    </b-form-group>
                                </b-tab>
                                <b-tab title="New Card">
                                     <b-row>
                                        <b-col cols="6">
                                            <label>NAME ON CARD</label>

                                            <input v-model="cardname" type="text" placeholder="Name on Card" class="form-control">
                                        </b-col>

                                        <b-col cols="6">
                                            <form name="tokenform" id="tokenform">
                                                <iframe id="tokenFrame" name="tokenFrame" :src="cardconnecturl" frameborder="0" scrolling="no"></iframe>
                                            </form>
                                        </b-col>
                                    </b-row>
                                </b-tab>
                            </b-tabs>

                            <b-row class="mt-3">
                                <b-col md="12" class="mb-3">
                                    <label for="">BILLING ADDRESS</label>

                                    <div class="row">
                                        <div class="col-12">
                                            <input
                                                id="autocompletesbox"
                                                v-model="billingaddress.billing_street_address"
                                                type="text"
                                                placeholder="Street Address"
                                                class="form-control"
                                            />
                                        </div>

                                        <div class="col-6">
                                            <input
                                                readonly
                                                v-model="billingaddress.billing_city"
                                                type="text"
                                                placeholder="City"
                                                class="form-control"
                                            />
                                        </div>

                                        <div class="col-3">
                                            <input
                                                readonly
                                                v-model="billingaddress.billing_state"
                                                type="text"
                                                placeholder="State"
                                                class="form-control"
                                            />
                                        </div>

                                        <div class="col-3">
                                            <input
                                                readonly
                                                v-model="billingaddress.billing_zip_code"
                                                type="text"
                                                placeholder="Zip"
                                                class="form-control"
                                            />
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                           
                           
                        </div>
                    </div>
                </b-col>
            </b-row>

        </div>
    </div>
</div>
</template>

<script>
// components

// mixins
import {cardconnectmixins} from '@/mixins/cardconnectmixins'
import {ordermixins} from '@/mixins/ordermixins'
import {gmapmixins} from '@/mixins/gmapmixins'

export default {
    mixins    : [gmapmixins, cardconnectmixins, ordermixins],
    data() {
        return {
            activetab   : 0
        }
    },
    computed : {
        /**
         * User data
         * 
         */
        user() {
           return this.$store.state.user
        },
        /**
         * User credit cards
         */
        usercreditcards() {
            return this.$store.state.usercreditcards
        },
        /**
         * orderboxes
         */
        orderboxes() {
            return this.$store.state.orderboxes
        },
        /**
         * Diable next button 
         * if no token
         * billing address
         * selected card if existing card is selected
         */
        disablenextbtn() {
            let disable = true;

            if(this.cardtoken && this.billingaddress.billing_address_latitude && this.billingaddress.billing_address_longitude) {
                disable = false;
            }

            return disable;
        }
    },
    filters: {
        /**
         * Format card expiration
         * @example MM / YYYY
         */
        formatcardexpiration(date) {
            if(!date) return ''
            const year  = date.substr(0, 4);
            const month = date.substr(date.length - 2, 2);
            
            return `${month} / ${year}`
        }
    },
    methods : {
        /**
         * Select default creditcard
         */
        getdefaultcard() {
            const card = this.usercreditcards.find(ucard => ucard.is_default)
            console.log('cardcard', card)

            if(card) { 
                this.getcarddetails(card)
                this.selectedcard = card.id
            }
        },
        /**
         * Get default billing address
         */
        getdefaultbilling() {
            const [sub] = this.$store.state.subscriptions

            if(sub) {
                const billing = {
                   billing_address_latitude : sub.billing_address_latitude,
                   billing_address_longitude: sub.billing_address_longitude,
                   billing_city             : sub.billing_address_city,
                   billing_state            : sub.billing_address_state,
                   billing_street_address   : sub.billing_address_street,
                   billing_zip_code         : sub.billing_address_zipcode
                }

                this.billingaddress = billing;
            }
        },
        /**
         * Get card detail if user selected an existing card
         */
        getcarddetails(card) {
            const cardobj = {
                card_id     : card.id,
                card_payment: 'existing_card'
            }

            const mergedetails  = {
                ...cardobj,
                ...this.billingaddress
            }

            this.cardtoken = mergedetails;
        },
        /**
         * autocomplete place will query from google map api to get address suggestion.
         * @param {DOM} inputbox input box where the autocomplete will trigger
         */
        autocompleteaddress() {
            const inputbox = document.getElementById('autocompletesbox');

            if(inputbox) {
                /**
                 * Callback
                 * Process return data from autocomplete address
                 */
                const callback = (data) => {
                   this.$nextTick(() => {
                        /**
                         * get latitude and longtitude
                         */
                        this.billingaddress.billing_address_latitude  = data.geometry.location.lat();
                        this.billingaddress.billing_address_longitude = data.geometry.location.lng();

                        /**
                         * get street, city, state, zipcode
                         */
                        // get street
                        const streetnumber = data.address_components.find(d => d.types.includes('street_number'));
                        const street       = data.address_components.find(d => d.types.includes('street'));
                        const route        = data.address_components.find(d => d.types.includes('route'));
                        
                        this.billingaddress.billing_street_address = `${streetnumber ? streetnumber.short_name : ''} ${street ? street.short_name : ''} ${route ? route.long_name : ''}`;
                        
                        // get city
                        const city              = data.address_components.find(d => d.types.includes('locality') || d.types.includes('postal_town'));
                              this.billingaddress.billing_city = city.long_name;

                        // get state
                        const state                             = data.address_components.find(d => d.types.includes('administrative_area_level_1'));
                              this.billingaddress.billing_state = state.short_name;

                        // get postal_code
                        const postalcode                       = data.address_components.find(d => d.types.includes('postal_code') || d.types.includes('postal_code_suffix'));
                              this.billingaddress.billing_zip_code = postalcode.short_name;

                        /**
                         * Check if there's card details 
                         * then merge addresss
                         */
                        if(this.cardtoken) {
                            const mergedetails = {
                                ...this.cardtoken,
                                ...this.billingaddress
                            }

                            this.cardtoken = mergedetails
                        }
                   });

                }

                this.autocompletedress(inputbox, callback);
            }
        },
        /**
         * Check if type of order
         * if for event redirect to ordereventschedule route
         * if subscription redirect to orderschedule route
         * 
         */
        scheduleselection() {
            const issubscription = this.$store.state.issubscription;

            if(issubscription) {
                this.$router.push({ name : 'orderschedule'});
            } else {
                this.$router.push({ name : 'ordereventschedule'});
            }
            
        }
    },
    /**
     * Run function before component render
     */
    async beforeMount() {
        //Initiatlize card connect
        this.initcardconnect();

        // Get user creditcards
        if(this.user && this.usercreditcards.length == 0) {
            await this.$store.dispatch('getcreditcards', this.user.id );

            // select default creditcard
            this.getdefaultcard()
        }

         /**
         * get box price
         */
        this.getorderforeventboxtype();
        
    },
    /**
     * Run function after component rendered
     */
    mounted() {
        // compute order summary
        this.computeordersummary();

        /**
         * Get subscription billing address
         */

        this.getdefaultbilling();

        // initiate address autocomplete
        // Initiate google map 
        this.$gmapApiPromiseLazy().then(() => {
            this.initMap();
            this.autocompleteaddress(); 
        });
    }
}
</script>

<style lang="scss">
@import '@/scss/_settings.scss';
@import '@/scss/global/_mixins.scss';

    .fzmPaymentDetails {
        iframe {
            min-height: 200px;
        }

        .backbtn {
            @include screen-up(lg) {
                margin-top : 50px;
            }
        }

        .form-control {
            border      : none;
            padding-left: 0;
        }

        .paymentCardDetail {
            .usercreditcards {
                img {
                    max-width   : 40px;
                    margin-right: 10px;
                }

                .custom-radio {

                    .custom-control-label {
                        font-size  : 25px;
                        font-weight: 300;

                        &::before, &::after {
                            top : 15px;
                        }
                    }

                }

            }
        }
    }
</style>